import React from 'react';
import { Action, Plugin } from '@devexpress/dx-react-core';

export default class CustomActionsState extends React.PureComponent {
  render() {
    const {onRefreshClick, onResetClick} = this.props;
      return (
          <Plugin
              name="CustomActionsState"
          >
              {onRefreshClick && <Action name="clickRefresh" action={onRefreshClick} />}
              {onResetClick && <Action name="clickReset" action={onResetClick} />}
          </Plugin>
      );
  }
}